// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import keyMirror from 'mattermost-redux/utils/key_mirror';

export default keyMirror({
    RECEIVED_MARKETPLACE_PLUGINS: null,
    GET_MARKETPLACE_PLUGINS_FAILURE: null,
});
